import React, { ReactChildren, ReactElement } from 'react';
import { useRouteMatch } from 'react-router';
import { Layout } from 'elmo-elements';

import { playerRoutes } from '@/app/routes';
import Menu from '@/components/Menu';
import Logout from '@/components/Logout';

interface TemplateProps {
  children: ReactChildren | ReactElement;
}

const Template = ({ children }: TemplateProps): ReactElement => {
  const isPlayerRouteMatch = useRouteMatch(
    Object.keys(playerRoutes).map((key) => playerRoutes[key].path),
  );
  const isLogoutRouteMatch = useRouteMatch('/logout');

  if (isLogoutRouteMatch) return <Logout />;
  if (isPlayerRouteMatch) return <div>{children}</div>;

  return <Layout menu={<Menu />}>{children}</Layout>;
};

export default Template;
